import styled from 'styled-components';

export const StyledContainer = styled.div`
  //width: 50%;
  background-color: #02044a;
  display: flex;
  justify-content: space-between;
  height: 100%;
`;
